<template>
	
	<div class="confirm_dialog" v-if="displayed">
		<div class="inner">			
			<div class="title">{{title}}</div>
			<div class="msg" v-html="msg"></div>
			<div class="btn">
				<div :class="this.options.cancel_class" @click="cancel()">Abbrechen</div>
				<div :class="this.options.ok_class" @click="ok()">Ok</div>
			</div>
		</div>
	</div>
	
</template>

<script>
  
	export default {
		name: 'ConfirmDialog',
		inject: [],
		components: {
			
		},
		data() {
			return {
				displayed: false,
				title: 'Titel',
				msg: 'Nachricht',
				cb_ok: undefined, cb_cancel: undefined,
				options: undefined
			}
		},
		methods: {
			
			show(title, msg, cb_ok, cb_cancel, options) {

				if (options === undefined) options = {};

				if (options.ok_class === undefined) options.ok_class = 'ok';
				if (options.cancel_class === undefined) options.cancel_class = 'cancel';

				this.title = title;
				this.msg = msg;
				this.cb_ok = cb_ok;
				this.cb_cancel = cb_cancel;
				this.options = options;
				
				this.displayed = true;
				
			},
			
			cancel() {

				this.displayed = false;
				
				if (this.cb_cancel !== undefined) {
					
					this.cb_cancel();

				}
				
			},
			
			ok() {

				this.displayed = false;

				if (this.cb_ok !== undefined) {

					this.cb_ok();

				}
				
			}
			
		}
	}

</script>

<style lang="scss">
	
	.confirm_dialog { z-index:100; position:fixed; left:0; top:0; width:100vw; height:100vh; background-color:rgba(0, 0, 0, 0.5); display:flex; justify-content:center; align-items:center;
		.inner { background-color:#FFFFFF; border-radius:10px; width:300px; display:flex; flex-direction:column; justify-content:stretch; align-items:stretch; overflow:hidden;
			.title { width:100%; padding:15px 0; text-align:center; font-weight:bold; font-size:1.2em; }
			.msg { padding:0 15px 30px 15px; text-align:center; flex-grow:1; }
			.btn { width:100%; border-top:1px solid #999999; display:flex; justify-content:stretch; flex-direction:row;
				& > div { flex-grow:1; text-align:center; height:50px; width:100%; display:flex; justify-content:center; align-items:center; cursor:pointer;
					&.ok,
					&.cancel { color: rgba(59, 130, 246); font-weight:bold; }
					&:hover { background-color:rgba(59, 130, 246); color:#FFFFFF; }
				}
				& > div:nth-child(1) { border-right:1px solid #999999; }
			}
		}
	}

</style>